export const createModuleI18nNamespaces = () => {
  return {
    list: (resource: string) => `module-${resource}-list`,
    form: ({
      type,
      tab,
      resource,
    }: {
      type: "edit" | "create";
      tab?: string;
      resource: string;
    }) => {
      if (tab) {
        return `module-${resource}-${type}-${tab}`;
      }
      return `module-${resource}-${type}`;
    },
    layout: (resource: string) => `module-${resource}-layout`,
  };
};
